import React, { useState } from 'react';
import {
	Paper,
	Box,
	Grid,
	Typography,
	Button,
	Divider,
} from '@material-ui/core';
import PriceIcon from './components/PriceIcon';
import RedeemIcon from '@material-ui/icons/Redeem';

import { useIsDesktop, useTranslations } from 'components/utilities';
import PriceSummaryList from 'components/elements/organisms/PriceSummaryList';
import useCar from '../../../../context/useCar';
import useStyles from './styles';
import { KeyRewardProgram } from './components/KeyRewardProgram';

const CarDetailsPriceSummary = ({ boxSizes }) => {
	const { t } = useTranslations();
	const { carDetails } = useCar();
	const { button, buttonIcon, icon } = useStyles();
	const [isSelect, showSelect] = useState(false);

	const isDesktop = useIsDesktop();

	return (
		<Paper>
			<Box {...boxSizes}>
				<Grid container spacing={1} alignItems="center">
					<Grid item xs="auto">
						<PriceIcon className={!isDesktop ? icon : null} />
					</Grid>
					<Grid item xs="auto">
						<Typography variant="h5" gutterBottom>
							{t('car.priceDetails')}
						</Typography>
					</Grid>
				</Grid>
				<PriceSummaryList data={carDetails} />
				<Divider />
				{(carDetails && carDetails.car && carDetails.car.supplier_name === 'key') &&
					<React.Fragment>
						{!isSelect && (
							<Button
								color="primary"
								variant="contained"
								className={button}
								onClick={() => showSelect(true)}
							>
								<RedeemIcon className={buttonIcon} />
								{t('car.key_reward_program_button')}
							</Button>
						)}
						{isSelect && <KeyRewardProgram />}
					</React.Fragment>
				}
			</Box>
		</Paper>
	);
};

export default CarDetailsPriceSummary;
